import React,{useEffect,useState} from "react";
import PartnerWithUSBanner from "../../../assets/images/PartnerWithUSBanner.png";
import partnerWithUsImg1 from '../../../assets/images/partnerWithUsImg1.png'
import partnerWithUsImg2 from '../../../assets/images/partnerWithUsImg2.png'
import { useNavigate } from "react-router-dom";


import styles from "./PartnerWithUs.module.scss";
import ImageTextSection from "../../CustomComponent/ImageTextSection.tsx";


const content = [
  `We invite business partners to join our mission and contribute to empowering learners with industry-relevant skills while building a successful and impactful business. Together, we can shape a brighter future.`,
];

const PartnerWithUs: React.FC = () => {
  return (
    <div id="partnerWithUs" className={styles.partnerWithUs}>
      <div className="container">
        <div className="">
          <Banner />
        </div>
      </div>
    </div>
  );
};
const Banner = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState<boolean>(false);
  useEffect(() => {
    const updateView = () => {
      setIsMobile(window.innerWidth < 992);
    };

    updateView();
    window.addEventListener("resize", updateView);

    return () => window.removeEventListener("resize", updateView);
  }, []);

  return (
    <div className="row g-0">
      <div className={`col-lg-3 col-md-12 col-sm-12 ${styles.partnerWithUsImg1}`}>
        <img src={partnerWithUsImg1} alt="partnerWithUsImg1" className="img-fluid" />
        
      </div>
      <div className="col-lg-6 col-md-12 col-sm-12">
        <div className={styles.partnerwithUsDiv}>
        <p className="heading text-center">Partner with Us</p>
        <p className="para text-center">We invite business partners to join our mission and contribute to empowering learners with industry-relevant skills while building a successful and impactful business. Together, we can shape a brighter future.</p>
      <div className="d-flex justify-content-center align-items-center w-100">
        <button className={`secondary-btn`} onClick={() => navigate('/partner-with-aptech')}>
        Know More
          </button>
          </div>
          </div>
      </div>
      {!isMobile && (
      <div className={`col-lg-3 col-md-12 col-sm-12 ${styles.partnerWithUsImg2}`}>
<img src={partnerWithUsImg2} alt="partnerWithUsImg2" />
      </div>
      )}
    </div>
  );
};

export default PartnerWithUs;
